import React, { useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import RequestList from './request-list'
import { REQUEST_LIST_TABS } from '../../../constant/my-requests'

function RequestTabs() {
    const [key, setKey] = useState(REQUEST_LIST_TABS.ACTIVE);
  
    return (
        <div>
            <Tabs
                id="request-tabs"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3 request-tabs"
            >
                <Tab eventKey={REQUEST_LIST_TABS.ACTIVE} title="Active Request" />
                <Tab eventKey={REQUEST_LIST_TABS.PAST} title="Past Request" />
                <Tab eventKey={REQUEST_LIST_TABS.CANCELLED} title="Cancelled Request" />
            </Tabs>
            <RequestList type={key} onChangeTab={setKey} />
        </div>
    );
};

export default RequestTabs;